import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  employerApplicationsKey,
  errorMessage,
  searchApplicationsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type UseSearchApplicationsProps = {
  searchValue: string;
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useSearchApplications = ({
  searchValue,
  setAlertText = () => { },
}: UseSearchApplicationsProps) => {
  const { data: searchApplicationsData, isFetching: isSearchingApplications } =
    useQuery({
      enabled: Boolean(searchValue && searchValue?.length > 2),
      queryKey: [searchValue, employerApplicationsKey],
      queryFn: () =>
        axiosInstance
          .post(searchApplicationsRoute, { query: searchValue })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
      refetchOnWindowFocus: false,
    });

  return {
    searchApplicationsData,
    isSearchingApplications,
  };
};
